import React from 'react';
import { Color } from 'swag-client-common/components/ui/color';
import { Toggle } from '../../../../ui/toggle';
import detailsClasses from '../details/details.scss';
const ChooseColor = ({
  number,
  variants,
  isSplitOrderModeOn,
  isSplitOrderModeAvailable,
  onColorClick,
  onToggleSplitOrder,
  splitColorsTooltip
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.block
  }, /*#__PURE__*/React.createElement("h5", {
    className: detailsClasses.blockTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: detailsClasses.number
  }, number), /*#__PURE__*/React.createElement("span", null, "Choose your colors")), isSplitOrderModeAvailable && /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.buttonContainerRight
  }, /*#__PURE__*/React.createElement(Toggle, {
    toggleId: "relatedPopupToggle",
    tooltipClassName: detailsClasses.tooltip,
    uncheckedLabel: "Multiple colors:",
    tooltipText: splitColorsTooltip,
    value: isSplitOrderModeOn,
    "data-button": "Split",
    onToggle: () => onToggleSplitOrder(!isSplitOrderModeOn)
  })), /*#__PURE__*/React.createElement("div", {
    className: detailsClasses.colorContainer
  }, variants.map(variant => !variant.isHidden && /*#__PURE__*/React.createElement(Color, {
    key: variant.color,
    isActive: variant.isActive,
    color: variant.color,
    name: variant.name,
    onClick: () => onColorClick(variant.index, variant.isActive),
    isActionable: true,
    showTooltip: true
  }))));
};
export default ChooseColor;